module.exports = __webpack_public_path__ + "aaa0630411b289d7925c6e83715028a1.png";